export enum ReportServiceEvents {
    reportChanged = 'ReportService:reportChanged',
    reportDeleted = 'ReportService:reportDeleted'
}